import React from 'react';
import { Url } from '@wix/da-url';
import FolderRibbon from '../../../../../Primitives/FolderRibbon';
import FolderCoverInfo from '../../../../../FolderCoverInfo';
import GallectionCoverDumbo from '../../../../../GallectionCoverDumbo';
import shopFolderThumbStyles from '../../ShopFolderThumb.scss';
const padding = parseInt(shopFolderThumbStyles['folder-thumb-padding']);
const FolderContent = ({ folder, width, height, hasBlurredCoverTooltip })=>{
    const thumb = folder.thumb;
    const thumbWidth = width ? width - padding * 2 : undefined;
    const thumbHeight = height - padding;
    return /*#__PURE__*/ React.createElement("a", {
        className: shopFolderThumbStyles['thumb'],
        href: Url.userGalleryLink({
            username: folder.owner.username,
            gallectionType: folder.type,
            folderId: folder.folderId,
            folderName: folder.name
        })
    }, /*#__PURE__*/ React.createElement(GallectionCoverDumbo, {
        gallection: folder,
        width: thumbWidth,
        height: thumbHeight
    }), thumb && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: shopFolderThumbStyles['thumb-overlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: shopFolderThumbStyles['thumb-overlay-top']
    }), hasBlurredCoverTooltip && /*#__PURE__*/ React.createElement("div", {
        className: shopFolderThumbStyles['top-right-icon']
    }, /*#__PURE__*/ React.createElement(FolderCoverInfo, null))), /*#__PURE__*/ React.createElement(FolderRibbon, {
        premiumFolderData: folder.premiumFolderData,
        className: shopFolderThumbStyles['folder-badge']
    }));
};
FolderContent.displayName = 'FolderContent';
export default FolderContent;
